import { combineReducers } from "redux";
import session from "./sessionReducer";
import header from "./headerReducer";
import sso from "./ssoReducer";
import dashboard from "./dashboardReducer";
import error from "./errorReducer";
import domain from "./domainReducer";
import common from "./commonReducer";
import portal from "./portalReducer";
import epic from "./epicReducer";
import videoVisit from "./videoVisitReducer";

let rootReducer = combineReducers({
    domain,
    sso,
    session,
    header,
    dashboard,
    error,
    common,
    portal,
    epic,
    videoVisit
});
rootReducer.cookiesObject = null;

export default rootReducer;
